import insertIntoComposer from 'actions/team_assist/lib/insert_into_composer';
import TeamAssistMessage from 'models/team_assist_message';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import qconsole from 'scripts/lib/qconsole';

export default class UseTeamAssistResponse {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId }) {
    const customerStores = this.context.stores.customers.storesFor(customerId);
    const message = customerStores.teamAssists.find(messageId);
    if (!message || !message.content) {
      qconsole.log(`UseTeamAssistResponse: message [${messageId}] not found or empty`);
      return;
    }

    const isSuggestedResponse = message.role === 'ai_response' && message.type === 'suggested_response';
    if (isSuggestedResponse) {
      this.context.analytics.track('Team Assist Suggested Response Used', {
        customerId,
        sessionId: message.sessionId,
        messageId,
      });
    }

    insertIntoComposer(this.context, customerStores, message.content);

    if (isSuggestedResponse) {
      this.markUsedOnBackend(customerId, messageId);
    }
  }

  // Fire-and-forget: recording the insertion must never block or fail the
  // composer insert. The latch lives on the stored message rather than local
  // component state so it also dedups across panel re-mounts.
  markUsedOnBackend(customerId, messageId) {
    const store = this.getStore(customerId);
    if (!store) {
      return;
    }
    const message = store.findBy({ id: messageId });
    if (!message || message.responseUsedAt) {
      return;
    }

    this.setResponseUsedAt(store, messageId, new Date().toISOString());

    this.context.gateways.teamAssist.markUsed({ customerId, messageId }).catch(err => {
      const currentStore = this.getStore(customerId);
      if (currentStore) {
        this.setResponseUsedAt(currentStore, messageId, undefined);
      }
      handleCommonErrors(this.context, err);
    });
  }

  getStore(customerId) {
    if (!this.context.stores.customers.has({ id: customerId })) {
      return null;
    }
    return this.context.stores.customers.storesFor(customerId).teamAssists;
  }

  setResponseUsedAt(store, messageId, responseUsedAt) {
    const message = store.findBy({ id: messageId });
    if (!message) {
      return;
    }
    store.addOrReplace(TeamAssistMessage.fromJs({ ...message.toJs(), responseUsedAt }));
  }
}
